export const categories = [
  {
    slug: 'hexin-fangfa',
    name: '秘密教学核心',
    description: '揭示课堂之外的核心学习方法论，打破传统教育的边界',
    icon: 'ri-lightbulb-line',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20illustration%20of%20hidden%20knowledge%20and%20learning%20methodology%2C%20soft%20warm%20amber%20and%20cream%20tones%2C%20geometric%20shapes%20representing%20secret%20teaching%20concepts%2C%20light%20paper%20texture%20background%2C%20elegant%20educational%20theme%2C%20no%20text&width=800&height=600&seq=cat-core&orientation=landscape'
  },
  {
    slug: 'yincang-jiqiao',
    name: '隐藏学习技巧',
    description: '那些被忽略但极其有效的学习策略与技巧',
    icon: 'ri-eye-off-line',
    color: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20illustration%20of%20hidden%20learning%20techniques%20and%20secret%20strategies%2C%20warm%20terracotta%20and%20beige%20color%20palette%2C%20abstract%20geometric%20patterns%2C%20soft%20gradient%20background%2C%20educational%20concept%20art%2C%20clean%20composition%2C%20no%20text&width=800&height=600&seq=cat-hidden&orientation=landscape'
  },
  {
    slug: 'gaoxiao-chuanshou',
    name: '高效知识传授',
    description: '如何以最高效的方式传递和吸收知识',
    icon: 'ri-rocket-line',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20illustration%20of%20efficient%20knowledge%20transfer%20and%20teaching%20methods%2C%20warm%20golden%20and%20ivory%20tones%2C%20flowing%20organic%20shapes%2C%20light%20airy%20background%2C%20modern%20educational%20art%2C%20no%20text&width=800&height=600&seq=cat-efficient&orientation=landscape'
  },
  {
    slug: 'jingying-celve',
    name: '精英教学策略',
    description: '顶尖学习者与教育者使用的教学策略揭秘',
    icon: 'ri-vip-crown-line',
    color: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20illustration%20of%20elite%20teaching%20strategies%20and%20advanced%20learning%2C%20warm%20sienna%20and%20cream%20color%20scheme%2C%20sophisticated%20geometric%20design%2C%20light%20textured%20background%2C%20educational%20excellence%20theme%2C%20no%20text&width=800&height=600&seq=cat-elite&orientation=landscape'
  },
  {
    slug: 'shendu-miji',
    name: '深度学习秘籍',
    description: '深入知识本质，掌握真正的深度学习心法',
    icon: 'ri-psychotherapy-line',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20illustration%20of%20deep%20learning%20secrets%20and%20profound%20knowledge%2C%20warm%20ochre%20and%20sand%20tones%2C%20layered%20geometric%20shapes%2C%20soft%20diffused%20background%2C%20contemplative%20educational%20art%2C%20no%20text&width=800&height=600&seq=cat-deep&orientation=landscape'
  }
];

export const allCategories = categories;